import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import ImportFeedbackTab from "./ImportFeedbackTab.jsx";
import UploadTab from "./UploadTab.jsx";
import DownloadTab from "./DownloadTab.jsx";
import {IMPORT_TYPES} from "../../../other/constants/OtherKeys.jsx";
import MapTab from "./MapTab.jsx";
import EditorBase from "../base/EditorBase.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import HistoryTab from "./HistoryTab.jsx";

const ARCHIVED_EXPORT_TYPES = [IMPORT_TYPES.tasks, IMPORT_TYPES.resources, IMPORT_TYPES.clients, IMPORT_TYPES.taskBudget]

export default class ImportBase extends EditorBase {
  static get $name() {
    return "ImportBase";
  }

  static get type() {
    return WIDGET_KEYS.importEditorType;
  }

  static get configurable() {
    return {
      title: "Import",
      autoShow: false,
      autoClose: false,
      closable: true,
      centered: true,
      minWidth: "30em",
      maxWidth: "100vw",
      width: "93em",
      minHeight: "600px",
      maxHeight: "100vh",
      height: "min(100vh, 800px)",
      draggable: true,
      modal: true,
      cls:"resize",
      stateId: PERSISTENCE_STATE_KEYS.importEditor,
      items: {
        tabs: {
          type: WIDGET_KEYS.swivuTabPanel,
          stateId: "swivu-import-editor-tab",
          listeners: {
            tabChange: 'up.onBeforeTabChangeHandler'
          },
          flex: 1,
          items: {
            uploadTab: { type: UploadTab.type },
            mapTab: { type: MapTab.type, hidden: true },
            downloadTab: { type: DownloadTab.type },
            importFeedbackTab: { type: ImportFeedbackTab.type, hidden: true },
            historyTab: { type: HistoryTab.type},
          }
        }
      }
    };
  }

  selectUploadedView(importType) {
    const defaultViewOfImportedData = this.context.viewManager.getDefaultViewByType(importType);
    if (defaultViewOfImportedData) {
      this.context.viewManager.selectView(defaultViewOfImportedData);
    }
  }

  onAfterRecordsImport(importResponseData, importType, otherParams) {
    const {importFeedbackTab, historyTab} = this.widgetMap;
    const { created_count = 0, updated_count = 0 } = importResponseData;
    const totalImportedRecords = created_count + updated_count;

    // Always show the import feedback tab
    importFeedbackTab.hidden = false;
    importFeedbackTab.editRecord({ importResponseData }, otherParams);
    this.widgetMap.tabs.activeTab = 3;

    // Only update the view if there were successful imports
    if (totalImportedRecords > 0) {
      this.selectUploadedView(importType);
    }

    // Always refresh the history tab to ensure it shows the latest data
    historyTab.editRecord(this.record, this.context, otherParams);
  }

  editRecord(record, context, otherParams) {
    const { canEdit, importType, labelIndex = 1, asyncTaskImportResult  } = record;
    this.record = record;
    const { uploadTab, downloadTab, mapTab, historyTab } = this.widgetMap;
    this.context = context;
    this.editorTitleRendering(this.widgetMap.tabs.activeItem)
    super.editRecord(record, context, otherParams)

    uploadTab.editRecord(record, context, {
      onBeforeImport: (files) => {
        if (IMPORT_TYPES.taskBudget === importType) {
          mapTab.hidden = false;
          mapTab.editRecord(record, context, { ...otherParams, files, onFinalizeImport: uploadTab.importEntity.bind(uploadTab) });
          this.widgetMap.tabs.activeTab = 1;
        }
      },
      onAfterImport: (importResponseData) =>
        this.onAfterRecordsImport(importResponseData, importType, {
          ...otherParams,
          labelIndex
        }),
      canEdit
    });
    historyTab.editRecord(record, context, otherParams);
    downloadTab.editRecord(record, context, { ...otherParams, isEntityArchive: ARCHIVED_EXPORT_TYPES.includes(record.importType) });

    if (asyncTaskImportResult) {
      this.onAfterRecordsImport(asyncTaskImportResult, importType, {
        ...otherParams,
        labelIndex
      });
    }
  }

  editorTitleRendering(activeItem) {
    const action = activeItem.title || "Import / Export";
    this.title = `${action} ${this.record.importHeader} From CSV file`;
  }

  onBeforeTabChangeHandler({activeItem}) {
    this.editorTitleRendering(activeItem);
  }

}

ImportBase.initClass();
